export const formatDate = date => {
  const weekDay = date.toLocaleString('nl-NL', {
    weekday: 'long'
  });
  const weekNumber = date.getDate();
  const month = date.toLocaleString('nl-NL', {
    month: 'long'
  });
  return "".concat(weekDay, " ").concat(weekNumber, " ").concat(month);
};
export const monthDiff = (d1, d2) => {
  let months;
  months = (d2.getFullYear() - d1.getFullYear()) * 12;
  months -= d1.getMonth();
  months += d2.getMonth();
  return months;
};
export const initiateDate = function () {
  let dateParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
  let resetDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  const date = new Date(dateParams);
  if (resetDate) {
    date.setDate(1);
  }
  return date;
};
export const doubleDigits = number => {
  return "0".concat(number).slice(-2);
};